<div class="main-content">
  <app-header [title]="'ODV_DOCUMENTS_FORM.TITLE' | translate" [subtitle]="'ODV_DOCUMENTS_FORM.SUBTITLE' | translate" />

  <div class="row pt-5 mt-4 mt-md-0">
    <div class="col-12">
      <app-icam-container [centralIcon]="true" [iconName]="'article'" [iconColor]="'#e30714'" [iconHeight]="'32px'">
        @if (!isLoading) {
          <div>
            <div class="form-container required-document-form d-flex flex-column">
              <div class="form-section required-doc-section w-100">
                <div class="d-flex align-items-center form-title mt-2" [ngClass]="isLight ? 'light' : 'dark'">
                  <div class="d-flex align-items-center p-2">
                    <img class="section-image" src="../../assets/icon/article.svg" alt="document" />
                  </div>
                  <div class="form-title-text-container">
                    <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                      {{ 'ODV_DOCUMENTS_FORM.DOCUMENT_DETAILS' | translate }}
                    </p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="input-wrapper">
                      <label for="docName">{{ 'ODV_DOCUMENTS_FORM.DOCUMENT_NAME' | translate }}</label>
                      <input
                        id="docName"
                        type="text"
                        class="form-control"
                        [value]="salesOrderDocument.sodName || ''"
                        [disabled]="true"
                      />
                    </div>
                  </div>
                </div>
                @if (isAdmin()) {
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper d-flex align-items-center gap-2">
                        <input
                          id="hiddenForCustomerPartner"
                          type="checkbox"
                          [checked]="!!salesOrderDocument.hiddenForCustomerPartner"
                          (change)="onToggleHiddenForCustomerPartner($any($event.target).checked)"
                        />
                        <label for="hiddenForCustomerPartner" class="mb-0">
                          {{ 'ODV_DOCUMENTS_FORM.HIDDEN_FOR_CUSTOMER_PARTNER' | translate }}
                        </label>
                      </div>
                    </div>
                  </div>
                }
                @if (salesOrderDocument.notes && salesOrderDocument.notes.trim()) {
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <label for="notes">{{ 'ODV_DOCUMENTS_FORM.NOTES' | translate }}</label>
                        <textarea class="form-control" id="notes" rows="3" [disabled]="true">{{
                          salesOrderDocument.notes
                        }}</textarea>
                      </div>
                    </div>
                  </div>
                }
                @if (salesOrderDocument.templateId) {
                  <div class="d-flex align-items-center form-title mt-2 mb-0" [ngClass]="isLight ? 'light' : 'dark'">
                    <div class="d-flex align-items-center p-2">
                      <img class="section-image" src="../../assets/icon/article.svg" alt="document" />
                    </div>
                    <div class="form-title-text-container">
                      <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                        {{ 'ODV_DOCUMENTS_FORM.TEMPLATE' | translate }}
                      </p>
                    </div>
                  </div>
                }
                @if (salesOrderDocument.templateId) {
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        <app-icam-file-downloader
                          [templateId]="salesOrderDocument.templateId"
                          [fileName]="salesOrderDocument.sodName || 'template'"
                        ></app-icam-file-downloader>
                      </div>
                    </div>
                  </div>
                }
                @if (canShowFileInput()) {
                  <div class="row">
                    <div class="col-12">
                      <div class="input-wrapper">
                        @if (salesOrderDocument.templateId) {
                          <div class="d-flex align-items-center form-title mt-2" [ngClass]="isLight ? 'light' : 'dark'">
                            <div class="d-flex align-items-center p-2">
                              <img class="section-image" src="../../assets/icon/article.svg" alt="document" />
                            </div>
                            <div class="form-title-text-container">
                              <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                                {{ 'ODV_DOCUMENTS_FORM.UPLOAD_DOCUMENT' | translate }}
                              </p>
                            </div>
                          </div>
                        }
                        <div class="d-flex align-items-center gap-2">
                          <label for="documentFile" class="custom-file-upload" [ngClass]="isLight ? 'light' : 'dark'">
                            <app-icam-icon iconName="attachment" />
                            {{ 'ODV_DOCUMENTS_FORM.CHOOSE_FILE' | translate }}
                          </label>
                          <div
                            class="popover-trigger"
                            ngbPopover="{{ 'acceptedFiles' | translate }}{{ 'ODV_DOCUMENTS_FORM.docs' | translate }}"
                            triggers="mouseenter:mouseleave"
                            popoverClass="icam-popover {{ isLight ? 'light' : 'dark' }}"
                          >
                            <app-icam-icon [iconName]="'info-circle'" />
                          </div>
                        </div>
                        <input
                          id="documentFile"
                          type="file"
                          style="display: none"
                          (change)="onFileSelected($event)"
                          accept=".pdf,.doc,.docx,.zip"
                        />
                        @if (selectedFile) {
                          <p class="text-muted" [ngClass]="isLight ? 'light' : 'dark'">
                            {{ selectedFile.name }}
                            <small
                              class="text-decoration-underline"
                              role="button"
                              (click)="removeFile()"
                              (keydown.enter)="removeFile()"
                              tabindex="0"
                            >
                              ({{ 'COMMON.REMOVE' | translate }})
                            </small>
                          </p>
                        }
                        <p class="text-muted mt-2 small doc-placeholder" [ngClass]="isLight ? 'light' : 'dark'">
                          {{ 'ODV_DOCUMENTS_FORM.FILE_UPLOAD_PLACEHOLDER' | translate }}
                        </p>
                      </div>
                    </div>
                  </div>
                }
                @if (_salesOrderDocumentId) {
                  <app-odv-history
                    #odvHistory
                    [salesOrderDocumentId]="_salesOrderDocumentId"
                    [uploadablePeriodically]="salesOrderDocument.uploadablePeriodically ?? null"
                    [canClear]="canShowFileInput()"
                    (pendingRemovalsChange)="pendingRemovals = $event"
                  >
                  </app-odv-history>
                }
                @if (canShowFileInput()) {
                  <button
                    type="button"
                    class="button-form-submit"
                    [class.disabled]="!canSubmit()"
                    [disabled]="!canSubmit()"
                    (click)="onSubmit()"
                  >
                    @if (isUploading) {
                      <div class="d-flex justify-content-center">
                        <div class="spinner-border spinner-border-sm" role="status"></div>
                      </div>
                    } @else {
                      {{ getUploadButtonLabel() | translate }}
                    }
                  </button>
                }
                @if (isUploading || uploadStatusMessage) {
                  <div class="mt-3">
                    @if (isUploading) {
                      <p class="text-primary mb-0">
                        {{ 'ODV_DOCUMENTS_FORM.UPLOADING' | translate }}
                      </p>
                    }
                    @if (uploadStatusMessage && !isUploading) {
                      <p [class]="uploadStatusType === 'success' ? 'text-success' : 'text-danger'" class="mb-0">
                        {{ uploadStatusMessage | translate }}
                      </p>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }

        @if (isLoading) {
          <div class="loading-container text-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">{{ 'COMMON.LOADING' | translate }}</span>
            </div>
            <p class="mt-3">{{ 'COMMON.LOADING' | translate }}</p>
          </div>
        }
      </app-icam-container>
    </div>
  </div>

  <div class="form-footer d-flex justify-content-between mt-4">
    <app-back-button
      class="app-back-button"
      [linkText]="'ODV_DOCUMENTS_FORM.BACK_TO_LIST' | translate"
      (click)="goBack()"
    ></app-back-button>
  </div>
</div>
<app-footer-copyright />
